module.exports = __webpack_public_path__ + "static/media/icon_leaf.6337b74c.svg";